import Vue from 'vue'

export default Vue.filter('pt-br', function (value) {
    if(value == null || value == undefined || value == '') return '';
    if(value.includes("T")){
        var date = new Date(value)
        return date.toLocaleDateString("pt-BR", { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',  })
    }
    return new Date(value).toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit', })
});

Vue.filter('money', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
  });
  return formatter.format(value);
});